import styled from "styled-components";

export const Container = styled("div")<{
  hover?:boolean;
  column?: boolean;
  padding?: string;
  width?: string;
  height?: string;
  background?: string;
  radius?: string;
  gap?: string;
  flex?: number;
  justifyContent?: string;
  border?: string;
  alignItems?: string;
  maxWidth?: string;
  margin?: string;
  wrap?: boolean;
  minHeight?:string;
}>`
  display: flex;
  flex-direction: ${({ column }) => (column ? "column" : "row")};
  ${({ padding }) => (padding ? `padding:${padding}` : "")};
  ${({ alignItems }) => (alignItems ? `align-items:${alignItems}` : "")};
  ${({ maxWidth }) => (maxWidth ? `max-width:${maxWidth}` : "")};
  ${({ minHeight }) => (minHeight ? `min-height:${minHeight}` : "")};
  ${({ width }) => (width ? `width:${width}` : "")};
  ${({ height }) => (height ? `height:${height}` : "")};
  ${({ background }) => (background ? `background:${background}` : "")};
  ${({ radius }) => (radius ? `border-radius:${radius}` : "")};
  ${({ gap }) => (gap ? `gap:${gap}` : "")};
  ${({ flex }) => (flex ? `flex:${flex}` : "")};
  ${({ border }) => (border ? `border:${border}` : "")};
  ${({ margin }) => (margin ? `margin:${margin}` : "")};
  ${({ wrap }) => (wrap ? `flex-wrap:wrap` : "")};
  ${({ hover }) => (hover ? `&:hover {
    opacity:0.7;
    background: #00000000;
  }` : "")};
  ${({ justifyContent }) =>
    justifyContent ? `justify-content:${justifyContent}` : ""};
`;

export const Link = styled("a")<{ active?: boolean; variant?: string; color?: string; }>`
    opacity:${({ active }) => (active ? "1" : "0.42")};
    text-decoration:none;
    color:${({ color }) => (color ? color : "inherit")};
    cursor: pointer;
`;


export const Select = styled("select")<{
  color?:string;
}>`
  background: transparent;
  font-family: Neue Montreal;
  font-size: 16px;
  font-weight: 400;
  line-height: 22.4px;
  outline: none;
  color: ${({ color }) => color || "#ffffff"};
  margin:0 0 0 13px;
  width:65px;
  cursor:pointer;
  & > option {
    background: transparent;
    color:  ${({ color }) => color || "#ffffff"};
    font-size: 16px;
  font-weight: 400;
  line-height: 22.4px;
  outline: none;

  }
`;

export const Input = styled("input")<{
  color?: string;
  width?: string;
  height?:string;
  border?: string;
  textAlign?: string;
  minWidth?:string;
}>`
 &::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
  background: transparent;
  font-family: Neue Montreal;
  font-size: 16px;
  font-weight: 400;
  line-height: 22.4px;
  outline: none;
  width: ${({ width }) => width || "auto"};
  height: ${({ height }) => height || "auto"};
  color: ${({ color }) => color || "#ffffff"};
  ${({ textAlign }) => textAlign ? `text-align: ${textAlign}`:'' };
  ${({ minWidth }) => minWidth ? `min-width: ${minWidth}`:'' };

  &::placeholder {
    color: ${({ color }) => color || "#ffffff"};
    font-family: Neue Montreal;
    font-size: 16px;
    font-weight: 400;
    line-height: 22.4px;
    opacity: 0.8;
  }
`;
